import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { suburbsByRegion, SUBURBS } from "@/data/suburbs";

export const AreasServed = () => {
  const groups = suburbsByRegion();
  return (
    <section className="mx-auto max-w-7xl px-5 py-16 lg:px-10 lg:py-20" data-testid="areas-served">
      <Reveal>
        <p className="mb-3 flex items-center gap-2 text-xs font-bold uppercase tracking-[0.3em] text-blaze">
          <MapPin className="h-4 w-4" /> Areas We Serve
        </p>
        <h2 className="font-display text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">
          Removalists across {SUBURBS.length}+ Melbourne suburbs
        </h2>
        <p className="mt-4 max-w-2xl text-base text-slate-700">
          MoversNearby provides cheap, reliable removalists and movers near you right across Greater
          Melbourne. Find your suburb below for local moving services.
        </p>
      </Reveal>

      <div className="mt-10 grid gap-x-10 gap-y-10 lg:grid-cols-2">
        {groups.map((group, gi) => (
          <Reveal key={group.region} delay={gi * 0.04}>
            <div data-testid={`areas-region-${gi}`}>
              <h3 className="mb-4 flex items-center gap-2 font-display text-sm font-bold uppercase tracking-[0.2em] text-slate-900">
                <span className="h-2 w-2 rounded-full bg-blaze" /> {group.region}
              </h3>
              <div className="flex flex-wrap gap-2">
                {group.suburbs.map((s) => (
                  <Link
                    key={s.slug}
                    to={`/removalists/${s.slug}`}
                    data-testid={`area-link-${s.slug}`}
                    className="rounded-full border border-slate-200 bg-white px-3.5 py-1.5 text-sm font-medium text-slate-700 transition-colors hover:border-blaze hover:text-blaze"
                  >
                    {s.name}
                  </Link>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
